import { Center, Loader, Space } from '@mantine/core';
import React, { memo } from 'react';

type Props = {
  absolute?: boolean;
};

function PageLoader({ absolute = true }: Props) {
  return (
    <Center flex={1} h={'100%'} w={'100%'} style={{ position: absolute ? 'absolute' : 'static' }}>
      <Space h={200} />
      <Loader id="loader" color="#F97F3E" data-testid="page-loader" />
    </Center>
  );
}

export default memo(PageLoader);
